import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const PaginaCaixa = styled(Box)(({ theme }) => ({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2.5),
    padding: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(2),
        gap: theme.spacing(2),
    },
}));
